<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Référence</th>
          <th class="text-left">Support</th>
          <th class="text-left">Couleur</th>
          <th class="text-left">Taille</th>
          <th class="text-left">P.U.</th>
          <th class="text-left">Quantité</th>
          <th class="text-left">Total</th>
        </tr>
      </thead>
      <tbody>
        <Item 
          v-for="item in items" 
          :key="item.id"
          :item="item"
        ></Item>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
  import Item from './Item'

  export default {
    name: 'Items',

    components: { Item },

    props: {
      items: Array,
    }
  }
</script>